<script setup lang="ts">
/**
 * `LoadProjectProgressView.vue` — full-screen overlay shown while a
 * project is loading.
 *
 * Mirrors `Content/Resources/Views/LoadProjectProgressView.prefab`
 * + `LoadProjectProgressViewModel`. Title is **`Loading {projectName}`**;
 * progress comes from `IProjectModel.onLoadProjectProgress`; cancel
 * routes through `IProjectModel.cancelLoadProject` (Unity's `OnCancel`).
 *
 * Self-contained: just drop `<LoadProjectProgressView />` anywhere in
 * the editor tree and it will show / hide based on the model events.
 */
import { computed } from "vue";
import ProgressView from "./_ProgressView.vue";
import { useLoadProjectProgress } from "@viewmodels/useLoadProjectProgress";

defineOptions({ name: "LoadProjectProgressView" });

const vm = useLoadProjectProgress();

// Bare "Loading" for the moment before the catalog knows the name (hard
// refresh / deep link) — never a placeholder project name.
const titleText = computed(() =>
  vm.projectName.value ? `Loading ${vm.projectName.value}` : "Loading",
);
</script>

<template>
  <Transition name="cf-progress-blur">
    <ProgressView
      v-if="vm.isVisible.value"
      :text="titleText"
      :percentage="vm.percentage.value"
      :log-text="vm.transferText.value"
      :can-cancel="vm.canCancel.value"
      :is-cancelling="vm.isCancelling.value"
      @cancel="vm.cancel"
    />
  </Transition>
</template>
